import React, { useEffect, useState } from 'react';
import { ImagePath } from '../../../../assets/ImagePath';
import { processSendMessage } from '../../../../services/bot/conversation/SendMessage';
import { setBotWaitLoaderWithShimmer } from '../../../../state/actions/loader';
import { MessageTypeConstants } from '../../../../services/bot/Message';
import CachedImage from '../../../common/CachedImage';
import ToggleFavoritesIcon from './ToggleFavoritesIcon';

const PullDownMenu = ({ pullDownMenuComponent, currentBotName, isSideBar, dispatch, handleSetFavorite, showFavoritesIcon, isFavoriteBot }) => {
    const { message } = pullDownMenuComponent;
    const [showDropdown, setShowDropdown] = useState(false);
    const [openSubMenu, setOpenSubMenu] = useState([]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            const isInsideDropdown = event.target.closest('.dropdown-container');
            const isMenuIcon = event.target.closest('.menu-icon');

            if (!isInsideDropdown && !isMenuIcon) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const toggleDropdown = () => {
        setShowDropdown((prev) => !prev);
    };

    const onSelectMenuItem = (id) => {
        handleAction(id);
        setShowDropdown(false);
    };

    const handleAction = (menuId) => {
        const responseChat = {
            messageType: MessageTypeConstants.MESSAGE_TYPE_MENU_RESPONSE,
            message: {
                controlId: message.options.controlId,
                tabId: message.options.tabId,
                selectedEntry: menuId,
            },
        };
        dispatch(setBotWaitLoaderWithShimmer(true));
        processSendMessage(responseChat);
    };

    const handleSubMenu = (id) => {
        setOpenSubMenu((prev) =>
            prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
        );
    };

    const renderList = (item) => (
        <div key={item.id} className="w-full">
            <div
                onClick={() => item.submenu ? handleSubMenu(item.id) : onSelectMenuItem(item.id)}
                className="flex items-center justify-between px-3 py-2 hover:bg-[#EBF6FF]  cursor-pointer text-size-15 text-[#333333] font-normal hover:font-semibold"
            >
                <div className="flex items-center gap-2">
                    <div className="w-[24px] text-center">
                        {item.icon ? (
                            <img src={item.icon}
                                alt=""
                                className="w-full h-full"
                            />
                        ) : (
                            <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M3 5h12M9 3v2m-6 4h18M9 9v2" />
                            </svg>
                        )}
                    </div>
                    <span className="">{item.label}</span>
                </div>

                {item.submenu && (
                    openSubMenu.includes(item.id) ? (
                        <svg onClick={(e) => { e.stopPropagation(); handleSubMenu(item.id); }}
                            className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
                        </svg>
                    ) : (
                        <svg onClick={(e) => { e.stopPropagation(); handleSubMenu(item.id); }}
                            className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                        </svg>
                    )
                )}
            </div>

            {item.submenu && openSubMenu.includes(item.id) && (
                <div className="ml-6 mt-1 space-y-1">
                    {item.submenu.map((subitem) => renderList(subitem))}
                </div>
            )}
        </div>
    );

    return (
        <div className="relative flex items-center gap-2 text-size-14 font-semibold">
            <CachedImage
                image={ImagePath.menuIcon}
                imgKey="menu-icon"
                alt="menu"
                onClick={toggleDropdown}
                className={`${isSideBar ? 'rotate-180' : ''} cursor-pointer !w-[16px] menu-icon`}
            />

            {currentBotName ? (
                currentBotName
            ) : (
                <div className="h-6 w-32 bg-gray-200 rounded animate-pulse" />
            )}

            {showFavoritesIcon && (
                <ToggleFavoritesIcon
                    isFavoriteBot={isFavoriteBot}
                    handleSetFavorite={handleSetFavorite}
                />
            )}

            {showDropdown && (
                <div className="absolute top-9 left-1 z-20 flex flex-col bg-white shadow-2xl text-size-13 pt-2 w-[180px] rounded-10 whitespace-nowrap dropdown-container overflow-hidden">
                    <p className='text-size-14 text-[#636363] font-normal px-3 pb-2'>Select Option</p>
                    {message?.menuEntries?.map((item) => renderList(item))}
                </div>
            )}
        </div>
    );
};

export default PullDownMenu;
